import { render, staticRenderFns } from "./RecaptchaCheckbox.vue?vue&type=template&id=446e76a8&scoped=true"
import script from "./RecaptchaCheckbox.vue?vue&type=script&lang=ts"
export * from "./RecaptchaCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./RecaptchaCheckbox.vue?vue&type=style&index=0&id=446e76a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e76a8",
  null
  
)

export default component.exports